import { createRouter, createRoute, createRootRoute } from '@tanstack/react-router'
import { AdminDashboard } from './pages/AdminDashboard'
import { ChallengesPage } from './pages/ChallengesPage'
import { ChallengeEditPage } from './pages/ChallengeEditPage'
import { CategoriesPage } from './pages/CategoriesPage'
import { CategoryEditPage } from './pages/CategoryEditPage'
import { LanguagesPage } from './pages/LanguagesPage'
import { LanguageEditPage } from './pages/LanguageEditPage'
import { UsersPage } from './pages/UsersPage'
import { UserEditPage } from './pages/UserEditPage'
import { AnalyticsPage } from './pages/AnalyticsPage'
import { LoginPage } from './pages/LoginPage'
import { Layout } from './components/Layout'

// Create wrapper components for create pages
const ChallengeCreatePage = () => <ChallengeEditPage />
const CategoryCreatePage = () => <CategoryEditPage />
const LanguageCreatePage = () => <LanguageEditPage />

const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">404 - Page Not Found</h1>
      <p className="text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
      <a href="/" className="bg-primary-600 text-white px-6 py-2 rounded-full hover:bg-primary-700 transition-colors">
        Go to Dashboard
      </a>
    </div>
  </div>
)

const rootRoute = createRootRoute({
  component: Layout,
  notFoundComponent: NotFound,
})

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
})

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: AdminDashboard,
})

const challengesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/challenges',
  component: ChallengesPage,
})

const challengeCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/challenges/create',
  component: ChallengeCreatePage,
})

const challengeEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/challenges/$challengeId',
  component: ChallengeEditPage,
})

const categoriesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/categories',
  component: CategoriesPage,
})

const categoryCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/categories/create',
  component: CategoryCreatePage,
})

const categoryEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/categories/$categoryId',
  component: CategoryEditPage,
})

const languagesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/languages',
  component: LanguagesPage,
})

const languageCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/languages/create',
  component: LanguageCreatePage,
})

const languageEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/languages/$languageCode',
  component: LanguageEditPage,
})

const usersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/users',
  component: UsersPage,
})


const userEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/users/$userId',
  component: UserEditPage,
})

const analyticsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/analytics',
  component: AnalyticsPage,
})

const routeTree = rootRoute.addChildren([
  loginRoute,
  indexRoute,
  challengesRoute,
  challengeCreateRoute,
  challengeEditRoute,
  categoriesRoute,
  categoryCreateRoute,
  categoryEditRoute,
  languagesRoute,
  languageCreateRoute,
  languageEditRoute,
  usersRoute,
  userEditRoute,
  analyticsRoute,
])

export const router = createRouter({ 
  routeTree,
  defaultNotFoundComponent: NotFound,
})